<section class="chart-card line-chart">
  <div class="chart-header">
    <h2>Production du parc</h2>
    <div class="chart-header-actions">
      <app-chart-period-selector
        [mode]="modeAffichage"
        [dateFin]="dateFin"
        (periodeChange)="onPeriodeChange($event)"
      />
      <div class="chart-menu-wrapper">
        <button class="menu-dots" aria-label="Options du graphique"
                (click)="toggleMenu($event)">
          <span></span>
        </button>
        @if (menuOuvert) {
          <div class="chart-dropdown" role="menu">
            <button class="chart-dropdown-item" role="menuitem"
                    (click)="ouvrirModal()">
              <span class="material-symbols-outlined">fullscreen</span>
              Afficher en grand
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <app-chart-host-overlay
    class="chart-area chart-area-line"
    [loading]="chargementGraphique"
    loadingLabel="Chargement du graphique..."
    ariaLabel="Graphique de production du parc"
    (hostReady)="onChartReady($event)"
  />
</section>

<app-chart-fullscreen-modal
  title="Production du parc"
  [chartRenderer]="chartRenderer"
  [(visible)]="modalVisible"
  [refreshToken]="modalRefreshToken"
  [loading]="chargementGraphique"
>
  <div chart-controls class="chart-header-actions">
    <app-chart-period-selector
      [mode]="modeAffichage"
      [dateFin]="dateFin"
      (periodeChange)="onPeriodeChange($event)"
    />
  </div>
</app-chart-fullscreen-modal>
